import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Term } from 'src/app/models/Term';

@Injectable({
    providedIn: 'root'
})
export class TermApi extends Api<Term> {}
